"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSystemComponentsUseCase = void 0;
const systems_1 = require("@/services/systems");
const systemComponents_1 = require("@/store/ducks/systemComponents");
function listSystemComponentsUseCase(systemId) {
    return async (dispatch) => {
        dispatch((0, systemComponents_1.listSystemComponents)());
        (0, systems_1.getSystem)(systemId).then((response) => dispatch((0, systemComponents_1.setSelectedSystemName)(response.name)));
        (0, systems_1.getSystemComponents)(systemId)
            .then((rawSystemComponents) => {
            const systemComponents = rawSystemComponents.map((rawSystemComponent) => {
                return {
                    unit: rawSystemComponent.unit,
                    id: rawSystemComponent.id,
                    systemId: rawSystemComponent.SystemComponent.systemId,
                    highValueLimit: rawSystemComponent.SystemComponent.highValueLimit || undefined,
                    name: rawSystemComponent.name,
                    lowValueLimit: rawSystemComponent.SystemComponent.lowValueLimit || undefined,
                    order: rawSystemComponent.order,
                };
            });
            dispatch((0, systemComponents_1.listSystemComponentsSuccess)(systemComponents));
        })
            .catch(() => {
            dispatch((0, systemComponents_1.listSystemComponentsError)());
        });
    };
}
exports.listSystemComponentsUseCase = listSystemComponentsUseCase;
